<script>
import EmbedOmnichannelSDK from '@/components/shared/embed-omnichannel-sdk/EmbedOmnichannelSDK.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'

import menus from '@/constants/menus'
import RedirectComponent from '@/components/redirect/RedirectComponent.vue'

export default {
  name: 'FuncionalidadeHandler',
  components: { RedirectComponent, EmbedOmnichannelSDK },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapState(['countEmbed']),
    ...mapState('login', ['token']),
    ...mapGetters('login', ['instanciasAutorizadasGestor', 'isGestorAtendimento']),
    ...mapState('SelecionaAplicacao', ['aplicacoes']),
    idConfigClienteApp () {
      return this.$route.params.idConfigClienteApp || ''
    },
    funcionalidade () {
      return this.$route.params.funcionalidade || ''
    },
    aplicacao () {
      if (!this.idConfigClienteApp) {
        return null
      }
      return this.aplicacoes.find(
        app => `${app.id_cliente_app}` === this.idConfigClienteApp
      ) || null
    },
    funcionalidadeConfig () {
      if (!this.funcionalidade) {
        return null
      }
      return menus.flatMap(menu => menu.childs || [])
        .find(child => child.routerName === this.funcionalidade) || null
    },
    embedPath () {
      if (!this.funcionalidadeConfig || !this.funcionalidadeConfig.embedPath) {
        return ''
      }
      return this.funcionalidadeConfig.embedPath
        .replace(':idConfigClienteApp', this.idConfigClienteApp)
    },
    url () {
      if (!this.funcionalidadeConfig || !this.funcionalidadeConfig.embedUrl) {
        return process.env.VUE_APP_URL_CONFIGURADOR_PUBLICO_FRONT
      }
      return this.funcionalidadeConfig.embedUrl
    },
    json () {
      const bundle = this.aplicacao ? this.aplicacao.bundle_mobile : ''
      const bundleWeb = this.aplicacao ? this.aplicacao.bundle_web : ''
      const idConfigClienteAppLocal = this.idConfigClienteApp ? this.idConfigClienteApp : null
      return {
        authorization: this.token,
        bundle: bundle,
        bundleWeb: bundleWeb,
        idConfigClienteApp: idConfigClienteAppLocal,
        instanciasAutorizadas: this.instanciasAutorizadas,
        isGestorAtendimento: this.isGestorAtendimento,
        parentUrl: window.location.href,
        path: this.embedPath
      }
    },
    actions () {
      return this.funcionalidadeConfig.actions || []
    }
  },
  methods: {
    ...mapMutations(['addCountEmbed'])
  },
  mounted () {
    this.addCountEmbed()
    setTimeout(() => { this.loading = false }, 1000)
  }
}
</script>

<template>
  <el-main :key="funcionalidade" v-if="!loading && funcionalidadeConfig">
    <redirect-component
      v-if="funcionalidadeConfig.externalLink"
      :to="funcionalidadeConfig.routerName"
      :idConfigClienteApp="idConfigClienteApp"
      :new-tab="funcionalidadeConfig.externalLinkNewTab"
    />
    <embed-omnichannel-s-d-k
      :key="countEmbed"
      :json="json"
      :url="url"
      :titulo="funcionalidadeConfig.name"
      :actions="actions"
      v-else
    />
  </el-main>
</template>

<style scoped>

</style>
